import { TRateCardDaySurcharges, TRateCardModifierType, TSimpleModifier, TTruckTypeModifier } from '@types';

export const modifierUnsetCheck = (value: unknown): boolean => {
	if (!value) {
		return true;
	}

	if ((value as TSimpleModifier)?.type === TRateCardModifierType.FIXED && (value as TSimpleModifier)?.value === '0') {
		return true;
	}

	if ((value as TRateCardDaySurcharges)?.sunday === null && (value as TRateCardDaySurcharges)?.saturday === null && (value as TRateCardDaySurcharges)?.public_holiday === null) {
		return true;
	}

	if ((value as TTruckTypeModifier)?.details && Object.values((value as TTruckTypeModifier)?.details || {}).every((detail) => detail?.type === TRateCardModifierType.FIXED && detail?.value === '0')) {
		return true;
	}

	return false;
}